/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/widget.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import {
    getFieldChangeItems,
    getProcessedFieldChangeItems,
    removePropertiesFromObject,
} from 'views/pages/admin/audit-log/service';
import Constants, { WidgetTypeCode } from '@utils/constants';

const propArray = ['IsDeleted', 'CfId'];

interface RecordProps {
    WidgetIds?: number[];
    WidgetNames: string;
    DisplayIndex?: number;
    DisplayName?: string;
    IconName?: number;
    TableCode?: number;
    TypeCode?: number;
    FieldName: string;
}

const WidgetAuditLogGrid = ({ oldRecord, newRecord, oldItem, newItem, record }: any) => {
    const {
        widgets: { IconsList },
        DataSourceLOV,
    } = Constants;

    const refactorRecord = (rec: RecordProps) => {
        // Add empty WidgetIds array to keep arrayOfObjectsV2 happy
        if (!rec.WidgetIds) {
            rec.WidgetIds = [];
        }

        return {
            ...rec,
            DisplayName: rec?.DisplayName,
            IconName: rec?.IconName ? IconsList.find((iconItem) => iconItem.value === rec.IconName)?.key : null,
            TypeCode: rec?.TypeCode ? WidgetTypeCode[rec?.TypeCode] : null,
            TableCode: rec?.TableCode ? DataSourceLOV.find((ds) => ds.value === rec.TableCode)?.key : null,
            FieldName: rec?.FieldName,
            DisplayIndex: rec.DisplayIndex,
            ...removePropertiesFromObject(record, propArray),
        } as Record<string, unknown>;
    };

    const refactoredOldRecord = refactorRecord(oldRecord as RecordProps);
    const refactoredNewRecord = refactorRecord(newRecord as RecordProps);

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({ oldRecord, newRecord, oldItem, newItem, field }),
    );

    return <FieldChangeGrid items={items} />;
};

export { WidgetAuditLogGrid };
